import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
    selector: 'progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    standalone: false
})
export class ProgressBarComponent implements OnInit {

  @Input() percentFilled : string | undefined = '0';
  @Input() backgroundColor : string | undefined = '#E0E0E0'; //light gray
  @Input() barFillColor : string | undefined = '3f51b5' //a dark blue
  @Input() width : string  = 'auto';
  @Input() height : string  = 'auto';

  constructor() { }

  ngOnInit(): void {
  }

}
